import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from 'recharts';
import { useTheme } from '../../../styles/ThemeProvider';
import { buildTooltipStyle } from './tooltipStyle';

const buildStacked = (items) => {
  let running = 0;
  return items.map((item, idx) => {
    if (item.total) {
      const row = { label: item.label, base: 0, bar: running, isTotal: true, kind: item.kind };
      return row;
    }
    const start = running;
    running += item.value;
    const isPositive = item.value >= 0;
    const base = isPositive ? start : running;
    const bar = Math.abs(item.value);
    return { label: item.label, base, bar, isPositive, isTotal: false, kind: item.kind };
  });
};

export const Waterfall = ({ items, formatter }) => {
  const { theme } = useTheme();
  const tip = buildTooltipStyle(theme);
  const data = buildStacked(items);
  const fillFor = (d) => {
    if (d.isTotal) return theme.color.brand;
    return d.isPositive ? theme.color.success : theme.color.danger;
  };
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid stroke={theme.color.border} strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="label" stroke={theme.color.muted} fontSize={12} tickLine={false} />
        <YAxis stroke={theme.color.muted} fontSize={12} tickLine={false} axisLine={false} tickFormatter={formatter} />
        <Tooltip
          {...tip}
          formatter={(v, _, ctx) => [formatter ? formatter(ctx.payload.bar) : ctx.payload.bar, ctx.payload.label]}
        />
        <Bar dataKey="base" stackId="wf" fill="transparent" />
        <Bar dataKey="bar" stackId="wf" radius={[2, 2, 0, 0]}>
          {data.map((d, i) => <Cell key={i} fill={fillFor(d)} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};
